import { render, staticRenderFns } from "./NovaDemanda.vue?vue&type=template&id=a59cb264&"
import script from "./NovaDemanda.vue?vue&type=script&lang=js&"
export * from "./NovaDemanda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.9.2_cache-loader@4.1.0_webpack@4.28.4_supports-color@6.1.0___css-loader@3_7d6ac29872945af8d84571788ffddadf/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports